// extracted by mini-css-extract-plugin
export default {"submitButton":"form_submitButton__Gi+8d"};